import { useQuery } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';

/**
 * GET /api/eraf/integration-hub/tcp/status — TCP 콘솔 상태 (INTEGRATION_READ)
 * queryKey: ['integration-hub', 'tcp', 'status']
 */
export function useTcpStatus() {
  return useQuery({
    queryKey: ['integration-hub', 'tcp', 'status'],
    queryFn: () => integrationHubApi.getTcpStatus(),
    staleTime: 30_000,
  });
}
